module.exports = __webpack_public_path__ + "img/ottercoin.8e42d57d.gif";